import { authStore } from "@/routes/login/auth-store"
import axios from "axios"

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true
})

let isAuthErrorHandled = false

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status
    const detail = error.response?.data?.detail

    // ! 진입점일때는 체크할 필요가 없다.
    // INFO: 진입점 = 로그인 페이지
    if (window.location.pathname === "/") {
      return Promise.reject(error)
    }

    if ((status === 401 || status === 403) && !isAuthErrorHandled) {
      isAuthErrorHandled = true

      if (status === 401 && detail?.includes("다른 환경에서 로그인")) {
        window.alert(
          "다른 기기(또는 브라우저)에서 로그인이 감지되어\n자동으로 로그아웃 되었습니다."
        )
      }

      authStore.getState().clearAuth()
      window.location.href = "/"
    }

    return Promise.reject(error)
  }
)

export default api
